import { PermissionString, Role } from "@cervval.js/common-permissions";
import { objectKeys } from "@cervval.js/common/src/tools/object.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import { ID } from "@ehealth_tools/common/src/data/propertyTypes/property.types";
import { AppLoginData } from "../users/appLoginData";
import { PermissionCategoryDTO } from "../users/permissionCategory.dto";

export interface AppPermissionContext {
    // GUIDED define here permission context. For example, if the user is part of the group 1 ; you can add groupIds:ID[]
    companyId?: ID;
}

/**
 * @returns roles of user (global roles and context related roles)
 */
export function getUserRoles(loginData: AppLoginData, permissionContext?: AppPermissionContext | undefined): Role[] {
    const roles: Role[] = [...loginData.globalRoles];
    if (permissionContext != null) {
        for (const context of objectKeys(permissionContext)) {
            const contextId = permissionContext[context];
            const contextRoles = contextId ? loginData.contextRoles?.[context]?.[contextId] : [];
            if (contextRoles) {
                roles.push(...contextRoles);
            }
        }
    }
    return roles;
}

/**
 * returns the permission string
 */
export function getPermissionString(enumValue: number, pEnum: anyReallyAny, category: PermissionCategoryDTO): PermissionString {
    // TODO remove trailing :r after refactor in Cervval.js
    return category.uid + ":" + pEnum[enumValue] + ":r" as PermissionString;
}